import axios from 'axios';

export default {
  getAll() {
    return axios.get('/roles');
  },
  create(body) {
    return axios.post('/roles', body);
  },
  update(id, body) {
    return axios.patch(`/roles/${id}`, body);
  },
  remove(id) {
    return axios.delete(`/roles/${id}`);
  },
};
